// src/views/Employees/Modal/EmployeeModal.jsx
import React, { useRef, useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import ActionsDataTable from "./ActionsDataTable";
import { getUserData } from "../system";
import { formatHours } from "./utility";
import EditAttendanceSessionModal from "./EditAttendanceSessionModal";
import { employeeConstants, modeConstants } from "../constants";
import { success } from "../redux/actions/utilities";
import { ToastifyService } from "../services";

export default function ViewAttendanceSessionsModal({ show, onHide }) {
  const initialGridState = {
    column: "",
    type: "",
    search: null,
    filters: [],
  };

  const sortingInProgressRef = useRef(false);
  const decryptedData = getUserData();

  const [gridState, setGridState] = useState(initialGridState);
  const [defaultPage, setDefaultPage] = useState(initialGridState.pageNumber);
  const [showModal, setShowModal] = useState(false);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();
  const rowData = useSelector((s) => s.employeeReducer.sessions);

  // load initial data in edit/view

  const title = "View Sessions";

  const columns = [
    {
      name: "Sr. No",
      selector: (row, index) => index + 1,
      sortable: false,
      width: "100px",
    },
    { name: "Check In At", selector: (row) => row.check_in_at },
    { name: "Check Out At", selector: (row) => row.check_out_at },
    { name: "Hours", selector: (row) => row.duration },
    {
      name: "Actions",
      sortable: false,
      width: "100px",
      cell: (row) =>
        !decryptedData.is_employee ? (
          <button
            type="button"
            className="btn btn-sm btn-outline-primary"
            title="Edit"
            aria-label="Edit"
            onClick={() => {
              getRowData(row);
              setShowModal(true);
            }}
          >
            <i className="bi bi-pencil" />
          </button>
        ) : null,
    },
  ];

  const getRowData = (row) => {
    dispatch(success(row, employeeConstants.EMPLOYEE_SESSION_FORM_DATA));
  };

  // ── Copy sessions to clipboard ──────────────────────────────────────────
  const handleCopySessions = () => {
    if (!rowData || rowData.length === 0) {
      ToastifyService.showError("No session data to copy.");
      return;
    }

    const header  = `Check In           Check Out          Hours`;
    const divider = `─`.repeat(46);
    const lines = rowData.map((row) => {
      const checkIn  = (row.check_in_at  || "-").padEnd(19);
      const checkOut = (row.check_out_at || "-").padEnd(19);
      const hours    = row.duration || "-";
      return `${checkIn}${checkOut}${hours}`;
    });

    const text = [header, divider, ...lines].join("\n");
    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      ToastifyService.showSuccess("Sessions copied to clipboard!");
      setTimeout(() => setCopied(false), 2500);
    }).catch(() => ToastifyService.showError("Copy failed."));
  };
  const onSort = (sortedColumn, sortDirection) => {
    sortingInProgressRef.current = true;
    const columnDirection = sortDirection ? sortDirection.toUpperCase() : null;
    setDefaultPage(gridState.pageNumber);
    setGridState((prevState) => ({
      ...prevState,
      orderBy:
        columnDirection !== null ? `${sortedColumn.id} ${columnDirection}` : "",
    }));
  };

  const onChangePage = (pageNumber) => {
    if (!sortingInProgressRef.current) {
      setGridState((prevState) => ({
        ...prevState,
        pageNumber: pageNumber,
      }));
    }
  };

  const onChangeRowsPerPage = (newPerPage, pageNumber) => {
    setGridState((prevState) => ({
      ...prevState,
      length: newPerPage,
      pageNumber: pageNumber,
    }));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body>
      <EditAttendanceSessionModal
        show={showModal}
        onHide={() => setShowModal(false)}
        mode ={modeConstants.UPDATE_MODE}
        onHideSessionModal = {onHide}
      />
        <ActionsDataTable
          columns={columns}
          filterColumns={[]}
          data={rowData}
          pagination
          highlightOnHover
          striped
          responsive
          persistTableHead
          selectableRows
          selectableRowsHighlight
          selectableRowsVisibleOnly
          paginationServer={false}
          onSort={onSort}
          gridState={gridState}
          paginationTotalRows={rowData?.length}
          onChangeRowsPerPage={onChangeRowsPerPage}
          onChangePage={onChangePage}
          paginationDefaultPage={defaultPage}
          paginationResetDefaultPage
          setGridState={setGridState}
          allowToolbar={false}
          allowFilters={false}
        />
      </Modal.Body>
    </Modal>
  );
}
